// Plazos de los extintores de la empresa (Mantenimiento M1, M50): uno por fila, con la norma que lo fija al lado. Son
// plazos máximos: la empresa los puede acortar, no alargar (la base lo controla). Viewer: solo lectura. "Volver a los
// de la norma" borra la fila de la empresa.

import React, { useEffect, useState } from 'react';
import { GuardadoVisible, type EstadoGuardado } from '../../components/tablero/Tablero';
import { PLAZOS_EXTINTOR, PLAZOS_NORMA, textoPlazo, type PlazosExtintor as Plazos } from '../../lib/mantenimiento/mant-tipos';
import { validarPlazos } from '../../lib/mantenimiento/mant-logica';
import { guardarPlazosExtintor, restablecerPlazosExtintor } from '../../lib/mantenimiento/mant-datos';

const msg = (e: unknown) => (e instanceof Error ? e.message : String(e));

interface Props {
  companyId: string;
  plazos: Plazos;
  propios: boolean;
  puedeEditar: boolean;
  onGuardado: (plazos: Plazos, propios: boolean) => void;
}

export default function PlazosExtintor(p: Props) {
  const [valores, setValores] = useState<Record<string, string>>({});
  const [estado, setEstado] = useState<EstadoGuardado>(null);
  const [detalle, setDetalle] = useState('');
  useEffect(() => { setValores(Object.fromEntries(PLAZOS_EXTINTOR.map(x => [x.clave, String(p.plazos[x.clave])]))); }, [p.plazos]);
  const pedidos = Object.fromEntries(PLAZOS_EXTINTOR.map(x => [x.clave, Number(valores[x.clave])])) as Plazos;
  const error = validarPlazos(pedidos);
  const cambia = PLAZOS_EXTINTOR.some(x => pedidos[x.clave] !== p.plazos[x.clave]);

  const guardar = async () => {
    if (error) { setEstado('error'); setDetalle(error); return; }
    setEstado('guardando'); setDetalle('');
    try { await guardarPlazosExtintor(p.companyId, pedidos); setEstado('guardado'); p.onGuardado(pedidos, true); }
    catch (e) { setEstado('error'); setDetalle(msg(e)); }
  };
  const restablecer = async () => {
    setEstado('guardando'); setDetalle('');
    try { await restablecerPlazosExtintor(p.companyId); setEstado('guardado'); p.onGuardado({ ...PLAZOS_NORMA }, false); }
    catch (e) { setEstado('error'); setDetalle(msg(e)); }
  };

  return (
    <section className="pe2-card mant-plazos" aria-label="Plazos de los extintores">
      <h3>Plazos de los extintores</h3>
      <p className="pe2-sub">Plazos de la NTE INEN 739:2016 y del AM 1257. Son máximos: la empresa los puede acortar, no alargar.
        {p.propios ? ' La empresa usa plazos propios.' : ' La empresa usa los de la norma.'}</p>
      <ul className="mant-lista">
        {PLAZOS_EXTINTOR.map(x => (
          <li key={x.clave}>
            <label className="pe2-campo mant-plazo">
              <span>{x.etiqueta} ({x.unidad === 'dias' ? 'días' : 'meses'})</span>
              <input type="number" inputMode="numeric" min={1} max={x.norma} step={1} disabled={!p.puedeEditar} value={valores[x.clave] ?? ''}
                onChange={e => { setValores(v => ({ ...v, [x.clave]: e.target.value })); setEstado(null); }} />
              <small>Norma: {x.fuente} (máximo {textoPlazo(x.norma, x.unidad)}).</small>
            </label>
          </li>
        ))}
      </ul>
      {cambia && error && <p className="tab-error" role="alert">{error}</p>}
      {p.puedeEditar && (
        <div className="pe2-acciones">
          <GuardadoVisible estado={estado} detalle={detalle} />
          {p.propios && <button type="button" className="pe2-btn" disabled={estado === 'guardando'} onClick={restablecer}>Volver a los de la norma</button>}
          <button type="button" className="pe2-btn primario" disabled={!cambia || !!error || estado === 'guardando'} onClick={guardar}>Guardar los plazos</button>
        </div>
      )}
    </section>
  );
}
